import STORE from '../../store';

const getTasksSnapshot = ({ accountId }: { accountId: string }) => {
  return STORE.getTasksRef({ accountId });
};

export default getTasksSnapshot;
